import type { RouteRecordRaw } from 'vue-router';

import { getDecodedBase64Deeplink } from '@/entities/base-64-deeplinks';

const MainPage = () =>
  import('@/pages/main').then(m => ({ default: m.MainPage }));
const HotOffersPage = () =>
  import('@/pages/hot-offers').then(m => ({ default: m.HotOffersPage }));
const FavoritesPage = () =>
  import('@/pages/favorites').then(m => ({ default: m.FavoritesPage }));
const FavoritesDirectionPage = () =>
  import('@/pages/favorites-direction').then(m => ({
    default: m.FavoritesDirectionPage,
  }));
const SearchPage = () => import('@/pages/search/SearchPage.vue');
const ResultsPage = () => import('@/pages/results/ResultsPage.vue');
const OfferDetailsPage = () =>
  import('@/pages/offer-details/OfferDetailsPage.vue');
const SpecialOffersPage = () =>
  import('@/pages/special-offers/SpecialOffersPage.vue');
const SpecialOfferDetailsPage = () =>
  import('@/pages/special-offer-details/SpecialOfferDetailsPage.vue');
const FareFamilyPage = () =>
  import('@/pages/booking/details').then(m => ({ default: m.FareFamilyPage }));
const PassengersDataPage = () =>
  import('@/pages/booking/details').then(m => ({
    default: m.PassengersDataPage,
  }));
const ProductsPage = () =>
  import('@/pages/booking/products').then(m => ({ default: m.ProductsPage }));
const AncillaryBaggagePage = () =>
  import('@/pages/booking/products').then(m => ({
    default: m.AncillaryBaggagePage,
  }));
const SeatMapPage = () =>
  import('@/pages/booking/products').then(m => ({ default: m.SeatMapPage }));
const QuickBookingPage = () =>
  import('@/pages/booking/quick-booking').then(m => ({
    default: m.QuickBookingPage,
  }));
const PaymentPage = () => import('@/pages/payment/PaymentPage.vue');
const SurchargePage = () =>
  import('@/pages/surcharge').then(m => ({ default: m.SurchargePage }));

export const routes: RouteRecordRaw[] = [
  {
    path: '/:source?',
    name: 'MainPage',
    component: MainPage,
    props: true,
  },
  {
    path: '/favorites',
    name: 'FavoritesPage',
    component: FavoritesPage,
  },
  {
    path: '/favorites/direction/:routeKey',
    name: 'FavoritesDirectionPage',
    component: FavoritesDirectionPage,
    props: true,
  },
  {
    path: '/hot-offers/:origCity/:destCountry/:source?',
    name: 'HotOffers',
    component: HotOffersPage,
    props: true,
  },
  {
    path: '/search/:hashCode/:source?',
    name: 'SearchPage',
    component: SearchPage,
    props: true,
    children: [
      {
        path: '',
        name: 'OffersResults',
        component: ResultsPage,
        props: true,
      },
      {
        path: 'details/:offerId',
        name: 'OfferDetails',
        component: OfferDetailsPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/fare-family/:source?',
        name: 'FareFamilyPage',
        component: FareFamilyPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/quick-booking/:source?',
        name: 'QuickBookingPage',
        component: QuickBookingPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/passengers/:source?',
        name: 'PassengersDataPage',
        component: PassengersDataPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/products/:source?',
        name: 'ProductsPage',
        component: ProductsPage,
        props: true,
      },
      {
        path: 'booking/:resultId/:offerId/baggage',
        name: 'AncillaryBaggagePage',
        component: AncillaryBaggagePage,
      },
      {
        path: 'booking/:resultId/:offerId/seat-map',
        name: 'SeatMapPage',
        component: SeatMapPage,
        props: true,
      },
    ],
  },
  {
    path: '/surcharge/:billId',
    name: 'SurchargePage',
    component: SurchargePage,
    props: true,
  },
  {
    path: '/payment/:orderId/:fromCabinet?',
    name: 'PaymentPage',
    component: PaymentPage,
    props: true,
  },
  {
    path: '/special-offers',
    name: 'SpecialOffersPage',
    component: SpecialOffersPage,
    props: true,
  },
  {
    path: '/special-offers/:offerId',
    name: 'SpecialOfferDetails',
    component: SpecialOfferDetailsPage,
    props: true,
  },
  {
    path: '/search/:hashCode/deep_link/details/:offerHash',
    redirect: to => ({
      name: 'OffersResults',
      params: { hashCode: to.params.hashCode, source: 'deep_link' },
      query: { offerHash: to.params.offerHash },
    }),
  },
  {
    path: '/search/:hashCode/sapp_button/details/:offerHash',
    redirect: to => ({
      name: 'OffersResults',
      params: { hashCode: to.params.hashCode, source: 'sapp_button' },
      query: { offerHash: to.params.offerHash },
    }),
  },
  {
    path: '/deeplink/base64/:encodedString',
    name: 'Base64Deeplink',
    redirect: to => {
      return getDecodedBase64Deeplink(to.params.encodedString as string);
    },
  },
];
